import { render, staticRenderFns } from "./LMScreen.vue?vue&type=template&id=2933d645&"
import script from "./LMScreen.vue?vue&type=script&lang=ts&"
export * from "./LMScreen.vue?vue&type=script&lang=ts&"
import style0 from "./LMScreen.vue?vue&type=style&index=0&id=2933d645&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports